import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Chaplin from "chaplin";
import RolloutHelper from "models/helper/FeatureRolloutHelper";
import DeepCutPopupView from "views/deepcut/DeepCutPopupView";
import ti18n from "i18n!nls/Sequenceri18n";
import RSVP from "rsvp";
import deepCutApi from "../../components/deepcut/services/deepcutApi.js";

const Rollout = RolloutHelper.getInstance();

const DeepCutPopupController = Chaplin.Controller.extend({

    initialize : function(options) {
        _.extend(this, Backbone.Events);
        this._transcriptText = options.transcriptText;
        this._transcriptId = options.transcriptId;
        this._projectId = options.projectId;
        this._onAnalysisComplete = options.onAnalysisComplete;
        this._onEditingPlanAppliedCallback = options.onEditingPlanApplied;
        this._isEditLikeMeMode = !!options.isEditLikeMeMode;

        // Clear any existing reference request UID when starting a new session
        deepCutApi.clearReferenceRequestUID();
        
        // Track DeepCut wizard started
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("deepcut", "wizard started", "DeepCut wizard opened", {
                transcriptId: this._transcriptId
            });
        }
        
        if(window.FacebookEventTrackingHelper){
            window.FacebookEventTrackingHelper.getInstance().trackDeepCutWizardStarted(this._transcriptId);
        }
    },

    getModel : function() {
        return this.model;
    },

    getView : function() {
        return this.view;
    },

    onPopupClosed : function(){
        // Cleanup if needed
    },

    _onAnalysisCompleted : function(analysisResults) {
        if (this._onAnalysisComplete && typeof this._onAnalysisComplete === 'function') {
            this._onAnalysisComplete(analysisResults);
        }
        
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("deepcut", "analysis completed", "DeepCut analysis completed", {
                transcriptId: this._transcriptId,
                hasResults: !!analysisResults
            });
        }
        
        // Track DeepCut wizard step completion
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("deepcut", "step completed", "DeepCut step 2 - analysis completed", {
                transcriptId: this._transcriptId,
                stepNumber: 2,
                stepName: "analysis_completed"
            });
        }
        
        // Track DeepCut wizard step completion for Facebook
        if(window.FacebookEventTrackingHelper){
            window.FacebookEventTrackingHelper.getInstance().trackDeepCutWizardStep(2, "analysis_completed", this._transcriptId);
        }
    },

    _onEditingPlanApplied : function(editingPlan) {
        if (this._onEditingPlanAppliedCallback && typeof this._onEditingPlanAppliedCallback === 'function') {
            this._onEditingPlanAppliedCallback(editingPlan);
        }

        // Close the popup after applying the editing plan
        this.view.close();
        
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("deepcut", "editing plan applied", "DeepCut editing plan applied", {
                transcriptId: this._transcriptId,
                planChips: editingPlan?.selectedChips?.length || 0
            });
        }
        
        // Track DeepCut wizard step completion
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("deepcut", "step completed", "DeepCut step 4 - editing plan applied", {
                transcriptId: this._transcriptId,
                stepNumber: 4,
                stepName: "editing_plan_applied",
                planChips: editingPlan?.selectedChips?.length || 0
            });
        }
        
        // Track DeepCut wizard step completion for Facebook
        if(window.FacebookEventTrackingHelper){
            window.FacebookEventTrackingHelper.getInstance().trackDeepCutWizardStep(4, "editing_plan_applied", this._transcriptId);
        }
    },

    _onWizardClosed : function() {
        // Handle when user closes wizard without completing
        this.view.close();
        
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("deepcut", "wizard closed", "DeepCut wizard closed without completion", {
                transcriptId: this._transcriptId
            });
        }
        
        // Track DeepCut wizard step completion
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("deepcut", "step completed", "DeepCut step 0 - wizard closed incomplete", {
                transcriptId: this._transcriptId,
                stepNumber: 0,
                stepName: "wizard_closed_incomplete"
            });
        }
        
        // Track DeepCut wizard step completion for Facebook
        if(window.FacebookEventTrackingHelper){
            window.FacebookEventTrackingHelper.getInstance().trackDeepCutWizardStep(0, "wizard_closed_incomplete", this._transcriptId);
        }
    },
    
    buildModelAndRenderView : function() {
        const promises = [];

        return RSVP.Promise.all(promises).then((function(){
            const params = {
                transcriptText: this._transcriptText,
                transcriptId: this._transcriptId,
                projectId: this._projectId,
                onAnalysisComplete: this._onAnalysisCompleted.bind(this),
                onEditingPlanApplied: this._onEditingPlanApplied.bind(this),
                onWizardClosed: this._onWizardClosed.bind(this),
                isEditLikeMeMode: this._isEditLikeMeMode
            };
            
            this.view = new DeepCutPopupView(params);
            this.listenTo(this.view, "closed", this.onPopupClosed);
            // DeepCutPopupView invokes these callbacks directly; listening to
            // the mirrored view events here would run close/analytics twice.

            this.view.render();

        }).bind(this))
    }

});

export default DeepCutPopupController;
